'use strict';

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

exports.func = Symbol('func');
exports.validate = Symbol('validate');